module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', [_c('li', {
    staticClass: "pull-left"
  }, [_c('h1', {
    staticClass: "header shadow-text"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Trump "), _c('abbr', {
    attrs: {
      "title": "For The Loss"
    }
  }, [_vm._v("FTL")])])], 1)]), _c('li', {
    staticClass: "media"
  }, [_c('router-link', {
    staticClass: "shadow-text",
    attrs: {
      "to": {
        path: '/latest'
      },
      "title": "Hot Stove"
    }
  }, [_c('icon', {
    attrs: {
      "name": "camera",
      "scale": "3",
      "color": "#333"
    }
  })], 1)], 1), _c('li', {
    staticClass: "comments"
  }, [_c('router-link', {
    staticClass: "shadow-text",
    attrs: {
      "to": {
        path: '/burnnn'
      },
      "title": "Burn Notice"
    }
  }, [_c('icon', {
    attrs: {
      "name": "fire",
      "scale": "3",
      "color": "#333"
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0322f3c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 1088
// module chunks = 1